export function IsIPad() {
    return [
        'iPad Simulator',
        'iPad',
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}